import React from 'react'
import {Loader, Dimmer, Button, List, Image} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'

class Invoices extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      invoices: []
    }
  }
  loadData () {
    const api = createAPIClient()
    this.setState({
      isLoading: true
    })
    api.get('/api/billing/invoices')
      .then(response => {
        this.setState({
          isLoading: false,
          invoices: response.data.invoices.data
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false
        })
        console.log(error)
      })
  }
  componentDidMount() {
    this.loadData()
  }
  render () {
    return (
      <div>

        <h1>Invoices</h1>
        <List divided verticalAlign='middle'>
          <Dimmer active={this.state.isLoading} inverted>
            <Loader>Loading</Loader>
          </Dimmer>
          {this.state.invoices.map(invoice => {
            return (
              <List.Item key={invoice.id} style={{minHeight: '50px'}}>
                <List.Content floated='right'>
                  {invoice.hosted_invoice_url ? <a className='button' href={invoice.hosted_invoice_url} target='_alt'>View Invoice</a>
                  : undefined
                  }
                </List.Content>
                <List.Content>
                  {invoice.lines.data[0].description}
                </List.Content>
              </List.Item>
            )
          })}
        </List>
      </div>
    )
  }
}

export default Invoices



// WEBPACK FOOTER //
// ./src/pages/settings/billing/components/invoices/index.js